export default "__VITE_ASSET__CiIrJ19L__"